import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ClientDetailPopup from "../../_default/Popup/ClientDetailPopup";
import "./ExerciseList.scss";
import ExerciseListItem from "./ExerciseListItem";

export default function ExerciseList({clientPlusAdminExercises, loading,setLoading, clients, set_exercise_history_tab, activeClient,clientPopUp, setlogging, history, exercises, removeExercise, from }) {
console.log("exersise list map",clientPlusAdminExercises?exercises.aurum:exercises, history)
let [totalExercises,setTotalExercises]=useState([])
console.log('Cliensss',clients)
useEffect(()=>{
  if(clientPlusAdminExercises){
    // debugger
    if(exercises.aurum&&exercises.coach){
      console.log("exer",[...Object.values(exercises)[0],...Object.values(exercises)[1]])
       totalExercises =exercises.aurum.concat(exercises.coach)
     setTotalExercises([...Object.values(exercises)[0],...Object.values(exercises)[1]])

    }
    
  }

},[exercises])
  return (
    <div className="c-exercise-list">
      {
        activeClient ?
          clients.length > 0 ? clients.map((client, idx) => {
            // console.log("exercise",exercise.id)
            return (
              <>
                <ExerciseListItem clients={clients} loading={loading} setLoading={setLoading} set_exercise_history_tab={set_exercise_history_tab} setlogging={setlogging} key={idx} client={client} activeClient={activeClient} history={history} from={from} idx={idx} removeExercise={removeExercise} />
             
              </>
            )


          }) : <span>No pending clients.</span>
         : 
          
          clientPlusAdminExercises?
          clientPlusAdminExercises && totalExercises.map((exercise, idx) => {
            // console.log("exercise",exercise.id)
            return (
              <>
                <ExerciseListItem setlogging={setlogging} key={idx} clients={clients} activeClient={activeClient} history={history} from={from} exercise={exercise} idx={idx} removeExercise={removeExercise} />
              </>
            )


          }):
          exercises && exercises.map((exercise, idx) => {
            // console.log("exercise",exercise.id)
            return (
              <>
                <ExerciseListItem clientPlusAdminExercises={true} setlogging={setlogging} key={idx} clients={clients} activeClient={activeClient} history={history} from={from} exercise={exercise} idx={idx} removeExercise={removeExercise} />
              </>
            )


          })
      }
    </div>
  );
}
